// extracted by mini-css-extract-plugin
export default {"h5":"H5-module__h5___E29Pj","bold":"H5-module__bold___fqr1V","muted":"H5-module__muted___oE0hP","inline":"H5-module__inline___pQyXJ"};